export const isExcluded = val =>
  val && (typeof val[0] === 'string' ? val[0] === '-' : val.isExcluded);
